import React from 'react';
import { FaGem, FaRegHandshake, FaShieldAlt } from 'react-icons/fa';

export const About = () => {
  return (
    <div className="p-8 mt-16 max-w-4xl mx-auto bg-white rounded-lg shadow-lg">
      <h1 className="text-4xl font-extrabold mb-6 text-center text-gray-800">About Us</h1>
      <p className="text-lg text-gray-700 mb-6 text-center">ShreeJewels is a renowned jewellery manufacturing shop known for its exquisite craftsmanship and exceptional service. Our commitment to quality and customer satisfaction has made us a trusted name in the industry.</p>
      
      <div className="space-y-8">
        <div className="flex items-center space-x-4">
          <FaGem className="text-green-500 w-8 h-8" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Exquisite Craftsmanship</h2>
            <p className="text-gray-600">At ShreeJewels, we pride ourselves on our attention to detail and the quality of our craftsmanship. Every piece of jewellery is meticulously crafted to perfection.</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-4">
          <FaRegHandshake className="text-green-500 w-8 h-8" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Exceptional Service</h2>
            <p className="text-gray-600">We are dedicated to providing exceptional customer service. Our team is always ready to assist you with your jewellery needs and ensure you have a pleasant shopping experience.</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-4">
          <FaShieldAlt className="text-green-500 w-8 h-8" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Commitment to Quality</h2>
            <p className="text-gray-600">Quality is at the heart of everything we do. We use only the finest materials and employ rigorous quality control measures to ensure that every piece of jewellery meets our high standards.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
